import AEBookTracker from '@/views/SAUT/AEBookTracker/Page.vue';
import AELeaderboard from '@/views/SAUT/AELeaderboard/Page.vue';
import AEPerformance from '@/views/SAUT/AEPerformance/Page.vue';
import AMBookTracker from '@/views/SAUT/AMBookTracker/Page.vue';
import AMLeaderboard from '@/views/SAUT/AMLeaderboard/Page.vue';
import AMPerformance from '@/views/SAUT/AMPerformance/Page.vue';
import ParentAccountTracker from '@/views/SAUT/ParentAccountTracker/Page.vue';
import SALeaderboard from '@/views/SAUT/SALeaderboard/Page.vue';
import SAPerformance from '@/views/SAUT/SAPerformance/Page.vue';
import SalesMasterReport from '@/views/SAUT/SalesMasterReport/Page.vue';
import SalesPerformance from '@/views/SAUT/SalesPerformance/Page.vue';

export default [
	{
		path: '/saut/ae-book-tracker/:account_manager_id?',
		name: 'AEBookTracker',
		component: AEBookTracker,
		meta: {
			title: 'SAut - AE Book Tracker',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/ae-leaderboard',
		name: 'AELeaderboard',
		component: AELeaderboard,
		meta: {
			title: 'SAut - Account Executive Leaderboard',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/ae-performance',
		name: 'AEPerformance',
		component: AEPerformance,
		meta: {
			title: 'SAut - Account Executive Performance',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/am-book-tracker/:account_manager_id?',
		name: 'AMBookTracker',
		component: AMBookTracker,
		meta: {
			title: 'SAut - AM Book Tracker',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/am-leaderboard',
		name: 'AMLeaderboard',
		component: AMLeaderboard,
		meta: {
			title: 'SAut - Account Manager Leaderboard',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/am-performance',
		name: 'AMPerformance',
		component: AMPerformance,
		meta: {
			title: 'SAut - Account Manager Performance',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/parent-account-tracker/:account_manager_id?',
		name: 'ParentAccountTracker',
		component: ParentAccountTracker,
		meta: {
			title: 'SAut - Parent Account Tracker',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/sa-leaderboard',
		name: 'SALeaderboard',
		component: SALeaderboard,
		meta: {
			title: 'SAut - Sales Associate Leaderboard',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/sa-performance',
		name: 'SAPerformance',
		component: SAPerformance,
		meta: {
			title: 'SAut - Sales Associate Performance',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/sales-master-report',
		name: 'SalesMasterReport',
		component: SalesMasterReport,
		meta: {
			title: 'SAut - Sales Master Report',
			permissions: 'saut',
		},
	},
	{
		path: '/saut/sales-performance',
		name: 'SalesPerformance',
		component: SalesPerformance,
		meta: {
			title: 'SAut - Sales Performance',
			permissions: 'saut',
		},
	},
];
